var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { InfoModalComponent } from "app/views/modal/info_modal.component";
var MailBodyModalComponent = /** @class */ (function (_super) {
    __extends(MailBodyModalComponent, _super);
    function MailBodyModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'Loading...';
        return _this;
    }
    Object.defineProperty(MailBodyModalComponent.prototype, "body", {
        set: function (body) {
            this._body = body;
            this.iframe.nativeElement.contentWindow.document.body.innerHTML = this._body;
        },
        enumerable: true,
        configurable: true
    });
    MailBodyModalComponent.prototype.ok = function () {
        this.close();
    };
    return MailBodyModalComponent;
}(InfoModalComponent));
export { MailBodyModalComponent };
